
const Circles = {
  0: {
    name: global.Translator.trans("packages.lang.BRONZE", {}, "js"),
    icon: "bronze",
    strokeColor: "#cd8e59",
    strokeWeight: 4,
    fillColor: "#cd8e59", //#cd8e59
    radius: 10000,
    label: "10km",
    size: 30,
  },
  1: {
    name: global.Translator.trans("packages.lang.SILVER", {}, "js"),
    icon: "silver",
    strokeColor: "#d1d1d1",
    strokeWeight: 4,
    fillColor: "#d1d1d1", //#d1d1d1
    radius: 20000,
    label: "20km",
    size: 36,
  },
  2: {
    name: global.Translator.trans("packages.lang.GOLD", {}, "js"),
    icon: "gold",
    strokeColor: "#ffc105",
    strokeWeight: 4,
    fillColor: "", //#ffc105
    radius: 30000,
    label: "30km",
    size: 42,
  },
  3: {
    name: global.Translator.trans("packages.lang.PLATINUM", {}, "js"),
    icon: "platinum",
    strokeWeight: 4,
    strokeColor: "#8fa5b8",
    fillColor: "", //#8fa5b8
    radius: 40000,
    label: "40km",
    size: 48,
  },
};

export default Circles;
